"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketInventoryConfigurationInput = {
    type: "structure",
    required: ["Bucket", "Id"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        Id: {
            shape: {
                type: "string"
            },
            location: "querystring",
            locationName: "id"
        }
    }
};
//# sourceMappingURL=DeleteBucketInventoryConfigurationInput.js.map